const { registerBlockType } = wp.blocks;
const { InspectorControls } = wp.blockEditor;
const { TextControl, Panel, PanelBody, PanelRow, Icon, Button, IconButton } = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import { TextRepeaterPanel } from "../CustomFields/CustomFields";

registerBlockType(
	"qteblocks/post-block-pros-and-cons", // Name of the block with a required name space
	{
		title: "Produkt Fördelar och Nackdelar",
		description: "Visa en ruta med för och nackdelar",
		icon: "align-pull-left", // Icon, from WP icons
		category: "qteblocks",

		attributes: {
			grade: {
				type: "string",
				default: "",
			},
			pros: {
				type: 'array',
				default: [],
			},
			cons: {
				type: 'array',
				default: [],
			},
		},

		edit(props) {

			return (
				<>
					<InspectorControls>
						<Panel>
							<PanelBody title="Betyg">
								<PanelRow>
									<TextControl
										placeholder="Ange betyg (t.ex. 4/5)"
										value={props.attributes.grade}
										onChange={(text) => props.setAttributes({ grade: text })}
									/>
								</PanelRow>
							</PanelBody>
						</Panel>

						<TextRepeaterPanel props={props} attributeKey='pros' label={'Fördel'} />
						<TextRepeaterPanel props={props} attributeKey='cons' label={'Nackdel'} />
					</InspectorControls>
					<ServerSideRender
						block="qteblocks/post-block-pros-and-cons"
						attributes={props.attributes}
					/>
				</>
			);
		},

		save(props) {
			return null; // See PHP side. This block is rendered on PHP.
		},
	},
);
